import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createListThpc, getThpcData, getCascadingOptions } from "../api/overview";

const initialState = {
  thpcdata: [],
  // Cascading dropdown options
  cascadingOptions: {
    thpc: [],
    disease_state: [],
    molecule: [],
    brand: [],
    indication: []
  },
  // Loading states for cascading dropdowns
  cascadingLoading: {
    thpc: false,
    disease_state: false,
    molecule: false,
    brand: false,
    indication: false
  },
  loading: false,
  error: null,
  listUUID: "",
};

const reducers = {
  SET_THPC_DATA: (state, action) => {
    state.thpcdata = action.payload;
  },
  SET_CASCADING_OPTIONS: (state, action) => {
    const { fieldType, options } = action.payload;
    state.cascadingOptions[fieldType] = options;
  },
  CLEAR_CASCADING_OPTIONS: (state, action) => {
    const { fieldTypes } = action.payload;
    fieldTypes.forEach(fieldType => {
      state.cascadingOptions[fieldType] = [];
    });
  },
  RESET_CASCADING_STATE: (state) => {
    state.cascadingOptions = {
      thpc: [],
      disease_state: [],
      molecule: [],
      brand: [],
      indication: []
    };
    state.cascadingLoading = {
      thpc: false,
      disease_state: false,
      molecule: false,
      brand: false,
      indication: false
    };
  }
};

const FETCH_THPC_DATA = createAsyncThunk(
  "createlist/FETCH_THPC_DATA",
  async (obj) => {
    const response = await getThpcData(obj);
    return response;
  }
);

const FETCH_CASCADING_OPTIONS = createAsyncThunk(
  "createlist/FETCH_CASCADING_OPTIONS",
  async (params) => {
    const response = await getCascadingOptions(params);
    return { ...response, fieldType: params.field_type };
  }
);

const CREATE_LIST = createAsyncThunk("createlist/CREATE_LIST", async (obj) => {
  const response = await createListThpc(obj);
  return response;
});

const createListSlice = createSlice({
  name: "createlist",
  initialState,
  reducers,
  extraReducers: (builder) => {
    builder
      .addCase(FETCH_THPC_DATA.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FETCH_THPC_DATA.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload && action.payload.data && action.payload.data.data) {
          state.thpcdata = action.payload.data.data;
        } else {
          state.thpcdata = [];
        }
      })
      .addCase(FETCH_THPC_DATA.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Cascading options handlers
      .addCase(FETCH_CASCADING_OPTIONS.pending, (state, action) => {
        const fieldType = action.meta.arg.field_type;
        state.cascadingLoading[fieldType] = true;
        state.error = null;
      })
      .addCase(FETCH_CASCADING_OPTIONS.fulfilled, (state, action) => {
        const { fieldType } = action.payload;
        state.cascadingLoading[fieldType] = false;
        state.cascadingOptions[fieldType] = action.payload.data.data;
      })
      .addCase(FETCH_CASCADING_OPTIONS.rejected, (state, action) => {
        const fieldType = action.meta.arg.field_type;
        state.cascadingLoading[fieldType] = false;
        state.error = action.error.message;
      })
      .addCase(CREATE_LIST.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(CREATE_LIST.fulfilled, (state, action) => {
        state.loading = false;
        state.listUUID = action.payload.data.data.uuid;
      })
      .addCase(CREATE_LIST.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { 
  SET_THPC_DATA, 
  SET_CASCADING_OPTIONS, 
  CLEAR_CASCADING_OPTIONS, 
  RESET_CASCADING_STATE 
} = createListSlice.actions;
export { FETCH_THPC_DATA, FETCH_CASCADING_OPTIONS, CREATE_LIST };
export default createListSlice.reducer;
